import ConditionalRule from "../../../common/models/conditionalRules/conditionalRule";
import Repo from "../../../common/state/modules/repo";
import IRepo from "../../../common/interfaces/repo";
import {DatetimeMode} from "~/models/datetimeMode";
import ProcessFlowMappedVariable from '~/models/processFlows/steps/processFlowMappedVariable'
import {IProcessFlowMappedVariable} from '~/interfaces/processFlowInterfaces'

export default class ProcessFlowStepElementConditionalRule extends ConditionalRule {
  referenced_value_id: string = null;
  is_reference: boolean = true;

  static repo: IRepo<ProcessFlowStepElementConditionalRule> = new Repo<ProcessFlowStepElementConditionalRule>('conditionalRules', ProcessFlowStepElementConditionalRule);

  get referencedControl(): IProcessFlowMappedVariable {
    return ProcessFlowMappedVariable.repo.find(this.referenced_control_id) || ProcessFlowMappedVariable.repo.find(this.referenced_control_id);
  }

  get datetimeMode(): DatetimeMode {
    return DatetimeMode.Datetime;
  }

  /**
   * Simply check right-hand "value" side to make sure it's been filled out (not necessarily correctly/valid)
   */
  get isComplete(): boolean {
    if (!this.referencedControl?.hasSource) return false
    if (this.isValueRequired && !this.referencedValue?.hasSource) return false
    return true
  }

  get referencedValue(): IProcessFlowMappedVariable {
    return ProcessFlowMappedVariable.repo.find(this.referenced_value_id) || ProcessFlowMappedVariable.repo.find(this.referenced_value_id);
  }

  // ******************** Name String Determination START ******************** //
  get referenceControlNameString(): string {
    return this.referencedControlName || '';
  }

  getValueString(id = null): string {
    return this.referencedValueName || '';
  }

  valueString(): string {
    return this.getValueString();
  }

  get referencedControlName(): string {
    return this.referencedControl?.referenceNameOrDefault;
  }

  get referencedValueName(): string {
    return this.referencedValue?.referenceNameOrDefault;
  }
  // ******************** Name String Determination END ******************** //
}